"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const input_1 = __importDefault(require("@kyruus/input"));
const prop_types_1 = __importDefault(require("prop-types"));
const read_only_1 = __importDefault(require("../../read-only"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const constants_1 = require("../../../constants");
const styles_1 = require("../../../styles");
const DIGITS_4 = 4;
const DIGITS_9 = 9;
const SSNInput = ({ path }) => {
    const [state, actions] = (0, use_form_1.default)(path, {
        eventProcessor: (event) => event.target.value
    });
    const { AddOn, config } = state;
    if (!config.isVisible)
        return null;
    if (config.isReadOnly) {
        return react_1.default.createElement(read_only_1.default, { msg: state.value });
    }
    const numDigits = config.type === constants_1.FIELD_TYPE_NAMES.PARTIAL_SSN ? 4 : 9;
    // default placeholder
    const myPlaceholder = config.placeholder || (numDigits === DIGITS_9 ? 'xxx-xx-xxxx' : 'xxxx');
    // when digits are 9, maxlength is 11 to accomodate dashes
    const maxLength = numDigits === DIGITS_4 ? 4 : 11;
    const formatStringAsSSN = (value) => {
        if (numDigits === DIGITS_4) {
            // don't reformat 4 digit ssn
            return value;
        }
        else {
            // strip out dashes
            let newValue = value.replace(/-/g, '');
            newValue = newValue.replace(/^([0-9]{3})([0-9])/, '$1-$2');
            newValue = newValue.replace(/(-[0-9]{2})([0-9])/, '$1-$2');
            newValue = newValue.replace(/([0-9])(-[0-9]{4}).*/, '$1$2');
            return newValue;
        }
    };
    const type = config.masked ? 'password' : 'text';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: Boolean(state.errors.length) },
            react_1.default.createElement(input_1.default, { type: type, errors: state.errors, required: config.isRequired, onChange: actions.onChange, onBlur: () => {
                    actions.onBlur({
                        target: { value: formatStringAsSSN(state.value) }
                    });
                }, value: state.value, placeholder: myPlaceholder, disabled: config.isReadOnly, name: path, label: config.label, id: path, hideLabel: true, "data-testid": path, maxLength: maxLength, inputMode: "numeric", pattern: "[0-9-]*" })),
        react_1.default.createElement(AddOn, null)));
};
SSNInput.propTypes = {
    path: prop_types_1.default.string.isRequired
};
exports.default = SSNInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map